import type { SVGProps } from 'react';
const DawnFlagBM = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-BM_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-BM_svg__a)">
      <path fill="#DC1F37" d="M0 0h22v16H0z" />
      <path fill="#042C90" d="M0 0h9.429v7.467H0z" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M13.62 8V5.333h4.19V8c0 1.6-2.096 2.667-2.096 2.667S13.62 9.6 13.62 8"
        clipRule="evenodd"
      />
      <mask
        id="dawn-flag-BM_svg__b"
        width={5}
        height={6}
        x={13}
        y={5}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M13.62 8V5.333h4.19V8c0 1.6-2.096 2.667-2.096 2.667S13.62 9.6 13.62 8"
          clipRule="evenodd"
        />
      </mask>
      <g mask="url(#dawn-flag-BM_svg__b)">
        <path
          fill="#65B5D2"
          fillRule="evenodd"
          d="M15.715 9.6c.578 0 1.047-.478 1.047-1.067s-.469-1.066-1.047-1.066c-.579 0-1.048.477-1.048 1.066S15.136 9.6 15.715 9.6"
          clipRule="evenodd"
        />
        <path
          fill="url(#dawn-flag-BM_svg__c)"
          fillRule="evenodd"
          d="M15.714 7.467c.29 0 .524-.24.524-.534a.53.53 0 0 0-.524-.533.53.53 0 0 0-.524.533c0 .295.235.534.524.534m-1.048 1.066c.29 0 .524-.239.524-.533a.53.53 0 0 0-.524-.533.53.53 0 0 0-.523.533c0 .294.234.533.523.533M17.286 8a.53.53 0 0 1-.524.533.53.53 0 0 1-.524-.533c0-.295.234-.533.524-.533.289 0 .523.238.523.533"
          clipRule="evenodd"
        />
        <path fill="#2F8F22" d="M13.619 9.6h4.19v1.067h-4.19z" />
      </g>
      <path
        fill="#DB1E36"
        fillRule="evenodd"
        d="M3.667 3.2 0 0h.524L4.19 2.667h1.048L9.428 0v.364a.33.33 0 0 1-.137.27L5.761 3.2v1.067L9.078 7.16a.175.175 0 0 1-.115.307"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M3.667 3.2v1.067L0 6.933v.534L4.19 4.8H5.24l3.62 2.633a.175.175 0 0 0 .218-.273L5.762 4.267V3.2L9.292.633a.33.33 0 0 0 .137-.27V0l-4.19 2.667H4.19L.524 0H0zm.74-1.2L.742-.667h-2.518L3 3.503v.424L-.666 6.594V8.68l5.051-3.214h.637l3.445 2.505a.84.84 0 0 0 .495.161c.778 0 1.14-.964.554-1.476L6.429 3.964V3.54l3.255-2.368a1 1 0 0 0 .412-.808v-1.578L5.044 2z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M0 2.667V4.8h3.667v2.533c0 .369.298.667.666.667h.762a.667.667 0 0 0 .667-.667V4.8h3.524a.667.667 0 0 0 .666-.667v-.8a.667.667 0 0 0-.666-.666H5.762V0H3.667v2.667z"
        clipRule="evenodd"
      />
      <path
        fill="url(#dawn-flag-BM_svg__d)"
        fillRule="evenodd"
        d="M0 3.2h4.19V0h1.048v3.2h4.19v1.067h-4.19v3.2H4.19v-3.2H0z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <linearGradient
        id="dawn-flag-BM_svg__c"
        x1={14.143}
        x2={14.143}
        y1={6.4}
        y2={8.533}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E20B0C" />
        <stop offset={1} stopColor="#D40001" />
      </linearGradient>
      <linearGradient
        id="dawn-flag-BM_svg__d"
        x1={0}
        x2={0}
        y1={0}
        y2={7.467}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DB1E36" />
        <stop offset={1} stopColor="#D51931" />
      </linearGradient>
    </defs>
  </svg>
);
export default DawnFlagBM;
